import { render } from "./App.vue?vue&type=template&id=14731a58"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
script.render = render

export default script